<app-dialog-simple
  [textContent]="{
    title: 'preautorisation-en-ligne.quitter-page.titre',
    titleId: 'titre-modale',
    paragraph: 'preautorisation-en-ligne.quitter-page.paragraphe',
    paragraphId: 'texte-modale',
    confirmButton: 'btn.oui',
    cancelButton: 'btn.non'
  }"
  (close)="close()"
  (confirm)="confirm()"
>
</app-dialog-simple>
